import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientList } from "./clientApi";

const initialState = {
  client: [],
  clientList: [],
  clientStatics: [],
  status: "",
};

export const clientListAsync = createAsyncThunk(
  "client/list",
  async (data, { dispatch }) => {
    const response = await clientList(
      data.page,
      data.pagesize,
      data.fechainicio,
      data.fechafinal,
      data.ambiente,
      data.estado,
      data.campoBusqueda,
      data.busqueda
    );
    dispatch(setList(response));
    return response;
  }
);

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    setList: (state, action) => {
      state.clientList = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(clientListAsync.pending, (state) => {
        state.status = "Loading";
      })
      .addCase(clientListAsync.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export const { setList } = clientSlice.actions;

export const Clients = (state) => state.client?.clientList;

export default clientSlice.reducer;

